import React from "react"
import { Menu } from "@mantine/core"

import { openChatWindow } from "app/static/frontend/imports/desktopHelperFunctions"
import urls from "app/static/frontend/imports/desktopPaths"
import sharedConstants from "shared/imports/sharedConstants"
import { sendUserAction } from "shared/user-actions/user-actions-action-creators"

import { Button, Icon } from "@/components"
import { useStyles } from "@/components/TopNavigation/components/Dropdown.styles"
import { useSupportChat } from "@/hooks/useSupportChat"

export const HelpActionsDropdown = ({ popdownIsOpen }) => {
    const { classes } = useStyles({
        loggedInAsUser: Boolean(Userdata.logged_in_as_user) || Boolean(Userdata.logged_in_as_user_from_regular_user),
        popdownIsOpen: popdownIsOpen,
    })

    const supportChat = useSupportChat()

    return (
        <Menu position="bottom-end" width="12.5rem">
            <Menu.Target>
                <Button variant="outline" className={classes.button}>
                    <Icon icon="question-circle" className={classes.topBarIcon} ariaLabel="Access support" />
                </Button>
            </Menu.Target>

            <Menu.Dropdown role="menu" className={classes.dropdown}>
                <Menu.Item className={classes.item} target="_blank" component="a" href={urls.zdHelpCenterHome}>
                    <Icon icon="info-circle" className={classes.icon} />
                    Help Center
                </Menu.Item>

                <Menu.Item className={classes.item} target="_blank" component="a" href={urls.whatsnew}>
                    <Icon icon="megaphone" className={classes.icon} />
                    What's New
                </Menu.Item>

                <Menu.Item className={classes.item} component="a" href={urls.contactUs}>
                    <Icon icon="life-ring" className={classes.icon} />
                    Contact Us
                </Menu.Item>

                {supportChat.isEnabled && (
                    <Menu.Item
                        className={classes.item}
                        onClick={() => {
                            openChatWindow()
                            sendUserAction(
                                DjangIO.app.useractions.types.UserActionType.live_chat,
                                window.location.pathname,
                            )
                        }}
                    >
                        <Icon icon="comments-alt" className={classes.icon} />
                        Launch Chat
                    </Menu.Item>
                )}

                <Menu.Item
                    className={classes.item}
                    target="_blank"
                    component="a"
                    href={sharedConstants.QUORUM_SCHOOL_URL}
                >
                    <Icon icon="graduation-cap" className={classes.icon} />
                    Quorum School
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}
